import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppTimeHeader from '../containers/AppTimeHeader'
import { withNamespaces } from "react-i18next"

class PaymentTimeError extends React.Component {
  handleRetry = () => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const qr = searchParams.get('qr');
    history.push(`/qrsale/${qr}`);
  }

  render() {
    const { t } = this.props;

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-center">
            <div className="time-error-icon">✕</div>
            <h3 className="time-title">{t('Error en el pago')}</h3>
            <p className="time-subtitle">{t('Ha ocurrido un error procesando tu pago. No se ha realizado ningún cargo.')}</p>
            <button className="time-continue-btn" onClick={this.handleRetry}>
              {t('VOLVER A INTENTAR')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PaymentTimeError));
